import { render } from "./zhiyeyaoshi-news.vue?vue&type=template&id=5bb471db&scoped=true"
import script from "./zhiyeyaoshi-news.vue?vue&type=script&lang=js"
export * from "./zhiyeyaoshi-news.vue?vue&type=script&lang=js"

import "./zhiyeyaoshi-news.vue?vue&type=style&index=0&id=5bb471db&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb471db"]])

export default __exports__